import { storeToRefs } from 'pinia';
import { useClient, type OnboardingStateEnum } from './useClient';
import { useAuthStore } from '@/stores/useAuthStore';
import { useAnalytics } from './useAnalytics';

export default () => {
  const { client } = useClient();
  const authStore = useAuthStore();
  const { me } = storeToRefs(authStore);
  const { identify } = useAnalytics();

  async function fetchMe() {
    const { data } = await client.users_me_retrieve();
    if (data) {
      me.value = data;
      identify(data.id);
    }
  }

  async function patchMe(body: { onboarding_state: OnboardingStateEnum }) {
    const { data, error } = await client.users_me_partial_update(body);
    if (data) me.value = data;
    return { data, error };
  }

  return { fetchMe, patchMe };
};
